import React, {useState} from 'react';
import {App, Button, Form, Input} from 'antd';
import {LockOutlined} from '@ant-design/icons';
import {userService} from '../../../services/userService';

interface ChangePasswordFormValues {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
}

interface ChangePasswordFormProps {
    onSuccess?: () => void;
}

const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({onSuccess}) => {
    const {message: messageApi} = App.useApp();
    const [form] = Form.useForm<ChangePasswordFormValues>();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (values: ChangePasswordFormValues) => {
        if (values.newPassword !== values.confirmPassword) {
            messageApi.error('两次输入的密码不一致');
            return;
        }

        if (values.oldPassword === values.newPassword) {
            messageApi.error('新密码不能与原密码相同');
            return;
        }

        try {
            setLoading(true);
            await userService.changePassword({
                oldPassword: values.oldPassword,
                newPassword: values.newPassword,
            });
            messageApi.success('密码修改成功');
            form.resetFields();
            onSuccess?.();
        } catch (error: any) {
            messageApi.error(error.message || '修改密码失败');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            requiredMark={false}
        >
            <Form.Item
                name="oldPassword"
                label="原密码"
                rules={[
                    {required: true, message: '请输入原密码'},
                    {min: 6, message: '密码至少6位'},
                ]}
            >
                <Input.Password
                    prefix={<LockOutlined/>}
                    placeholder="请输入原密码"
                    autoComplete="current-password"
                />
            </Form.Item>

            <Form.Item
                name="newPassword"
                label="新密码"
                rules={[
                    {required: true, message: '请输入新密码'},
                    {min: 6, max: 20, message: '密码长度需在6-20位之间'},
                ]}
            >
                <Input.Password
                    prefix={<LockOutlined/>}
                    placeholder="请输入新密码"
                    autoComplete="new-password"
                />
            </Form.Item>

            <Form.Item
                name="confirmPassword"
                label="确认新密码"
                rules={[
                    {required: true, message: '请确认新密码'},
                    {min: 6, message: '密码至少6位'},
                ]}
            >
                <Input.Password
                    prefix={<LockOutlined/>}
                    placeholder="请再次输入新密码"
                    autoComplete="new-password"
                />
            </Form.Item>

            <Form.Item style={{marginBottom: 0}}>
                <Button type="primary" htmlType="submit" block loading={loading}>
                    修改密码
                </Button>
            </Form.Item>
        </Form>
    );
};

export default ChangePasswordForm;
